var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Location") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Location",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(7.000000, 3.000000)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6331667,6.0335 C14.4556167,7.85595 14.4556167,10.8107167 12.6331667,12.6331667 C10.8107167,14.4556167 7.85595,14.4556167 6.0335,12.6331667 C4.21105,10.8107167 4.21105,7.85595 6.0335,6.0335 C7.85595,4.21105 10.8107167,4.21105 12.6331667,6.0335",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8766667,23.0133333 C14.4516667,19.8333333 18,14.4233333 18,9.79333333 C18,4.83333333 14.3466667,0.666666667 9.33333333,0.666666667 C4.32,0.666666667 0.666666667,4.68666667 0.666666667,9.645 C0.666666667,16.5633333 9.33333333,26 9.33333333,26 C9.33333333,26 11.26,23.775 11.8766667,23.0133333 L11.8766667,23.0133333 Z",
    id: "Shape",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.99b4374ed5eaa21eb69bb5f5a017e199.svg";
export { ForwardRef as ReactComponent };